<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
    <div class="container">
      <ul>
        <li><router-link to="/">HARUMIFLAG</router-link></li>
        <li><router-link to="/event/">イベント一覧</router-link></li>
        <li v-if="eventDetail.acf?.title != ''"><router-link :to="'/event/' + eventDetail.id">{{ eventDetail.acf?.title }}</router-link></li>
        <li v-else><router-link :to="'/event/' + eventDetail.id">{{ eventDetail.acf?.explanation }}</router-link></li>
      </ul>
    </div>
    </div>
    <div class="event-detail">
      <div class="event-detail__cont">
        <div class="container">
          <div class="event-detail__holder">
            <h2 class="page--title" v-if="!isLoading">EVENT<span>イベント</span></h2>
            <div class="skeleton-parent" v-if="isLoading">
              <PuSkeleton style="height: 60px;" :count="1"/>
            </div>
            <div class="cont-top" :class="eventList.length === 0 ? 'cont-top-custom' : ''">
              <div class="text-top" v-if="eventDetail.acf?.start_date && !isLoading">公開日：<span>{{ formatDate(eventDetail.acf?.start_date) }}</span>({{ formatWeekDay(eventDetail.acf?.start_date) }})</div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton :count="1"/>
              </div>
              <h2 v-if="eventDetail.acf?.title && !isLoading">
                {{ eventDetail.acf?.title }}
              </h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin: 5px 0;">
                <PuSkeleton style="height: 25px;" :count="1"/>
              </div>
              <ul class="list-tag" v-if="eventDetail.acf?.genre_icon || eventDetail.acf?.target_icon || eventDetail.acf?.organizer_icon && !isLoading">
                <li v-if="eventDetail.acf?.genre_icon">{{ eventDetail.acf?.genre_icon }}</li>
                <li v-if="eventDetail.acf?.target_icon">{{ eventDetail.acf?.target_icon }}</li>
                <li v-if="eventDetail.acf?.organizer_icon">{{ eventDetail.acf?.organizer_icon }}</li>
              </ul>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 20px;">
                <PuSkeleton style="height: 20px;" :count="1"/>
              </div>
              <div class="eventdetail__img__list">
                <div class="cont-featureimg"
                :class="
                eventDetail.acf?.event_date_txt || 
                eventDetail.acf?.event_place || 
                eventDetail.acf?.event_content || 
                eventDetail.acf?.event_inquiry || 
                eventDetail.acf?.reserve_url ||
                eventDetail.acf?.explanation ||
                (eventDetail.acf?.file1 &&
                eventDetail.acf?.file_name1) ||
                (eventDetail.acf?.file2 &&
                eventDetail.acf?.file_name2) ||
                (eventDetail.acf?.file3 &&
                eventDetail.acf?.file_name3) ||
                (eventDetail.acf?.file4 &&
                eventDetail.acf?.file_name4) ||
                (eventDetail.acf?.file5 &&
                eventDetail.acf?.file_name5) ? '' : 'img-custom'" v-if="eventDetail.acf?.image1 && !isLoading && eventDetail.acf?.image1 != '' && eventDetail.acf?.image1 != false"
                :style="{backgroundImage: `url(${$func.formatUrl(eventDetail.acf?.image1)})`}"
                >
                  <img
                    :src="$func.formatUrl(eventDetail.acf?.image1)"
                    alt="event feature img"
                  />
                </div>
                <div class="cont-featureimg"
                :class="
                eventDetail.acf?.event_date_txt || 
                eventDetail.acf?.event_place || 
                eventDetail.acf?.event_content || 
                eventDetail.acf?.event_inquiry || 
                eventDetail.acf?.reserve_url ||
                eventDetail.acf?.explanation ||
                (eventDetail.acf?.file1 &&
                eventDetail.acf?.file_name1) ||
                (eventDetail.acf?.file2 &&
                eventDetail.acf?.file_name2) ||
                (eventDetail.acf?.file3 &&
                eventDetail.acf?.file_name3) ||
                (eventDetail.acf?.file4 &&
                eventDetail.acf?.file_name4) ||
                (eventDetail.acf?.file5 &&
                eventDetail.acf?.file_name5) ? '' : 'img-custom'"
                  :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }"
                  v-if="eventDetail.acf?.image1 === '' || eventDetail.acf?.image1 === false" > 
                  <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
                </div>
                <div class="cont-featureimg"
                :class="
                eventDetail.acf?.event_date_txt || 
                eventDetail.acf?.event_place || 
                eventDetail.acf?.event_content || 
                eventDetail.acf?.event_inquiry || 
                eventDetail.acf?.reserve_url ||
                eventDetail.acf?.explanation ||
                (eventDetail.acf?.file1 &&
                eventDetail.acf?.file_name1) ||
                (eventDetail.acf?.file2 &&
                eventDetail.acf?.file_name2) ||
                (eventDetail.acf?.file3 &&
                eventDetail.acf?.file_name3) ||
                (eventDetail.acf?.file4 &&
                eventDetail.acf?.file_name4) ||
                (eventDetail.acf?.file5 &&
                eventDetail.acf?.file_name5) ? '' : 'img-custom'" v-if="eventDetail.acf?.image2 && !isLoading"
                :style="{backgroundImage: `url(${$func.formatUrl(eventDetail.acf?.image2)})`}"
                >
                  <img
                    :src="$func.formatUrl(eventDetail.acf?.image2)"
                    alt="event feature img"
                  />
                </div>
                <div class="cont-featureimg"
                :class="
                eventDetail.acf?.event_date_txt || 
                eventDetail.acf?.event_place || 
                eventDetail.acf?.event_content || 
                eventDetail.acf?.event_inquiry || 
                eventDetail.acf?.reserve_url ||
                eventDetail.acf?.explanation ||
                (eventDetail.acf?.file1 &&
                eventDetail.acf?.file_name1) ||
                (eventDetail.acf?.file2 &&
                eventDetail.acf?.file_name2) ||
                (eventDetail.acf?.file3 &&
                eventDetail.acf?.file_name3) ||
                (eventDetail.acf?.file4 &&
                eventDetail.acf?.file_name4) ||
                (eventDetail.acf?.file5 &&
                eventDetail.acf?.file_name5) ? '' : 'img-custom'" v-if="eventDetail.acf?.image3 && !isLoading"
                :style="{backgroundImage: `url(${$func.formatUrl(eventDetail.acf?.image3)})`}"
                >
                  <img
                    :src="$func.formatUrl(eventDetail.acf?.image3)"
                    alt="event feature img"
                  />
                </div>
                <div class="cont-featureimg"
                :class="
                eventDetail.acf?.event_date_txt || 
                eventDetail.acf?.event_place || 
                eventDetail.acf?.event_content || 
                eventDetail.acf?.event_inquiry || 
                eventDetail.acf?.reserve_url ||
                eventDetail.acf?.explanation ||
                (eventDetail.acf?.file1 &&
                eventDetail.acf?.file_name1) ||
                (eventDetail.acf?.file2 &&
                eventDetail.acf?.file_name2) ||
                (eventDetail.acf?.file3 &&
                eventDetail.acf?.file_name3) ||
                (eventDetail.acf?.file4 &&
                eventDetail.acf?.file_name4) ||
                (eventDetail.acf?.file5 &&
                eventDetail.acf?.file_name5) ? '' : 'img-custom'" v-if="eventDetail.acf?.image4 && !isLoading"
                :style="{backgroundImage: `url(${$func.formatUrl(eventDetail.acf?.image4)})`}"
                >
                  <img
                    :src="$func.formatUrl(eventDetail.acf?.image4)"
                    alt="event feature img"
                  />
                </div>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <div v-for="(n, index) in 1" :key="index" >
                  <PuSkeleton :style="{height: `500px` }" :count="1"/>
                </div>
              </div>
              <div class="cont-decs" v-if="eventDetail.acf?.event_date_txt || eventDetail.acf?.event_place || eventDetail.acf?.event_content || eventDetail.acf?.event_inquiry || (eventDetail.acf?.reserve_url && !['予約不要', '非表示'].includes(eventDetail.acf?.reserve))">
                <div class="decs__row" v-if="eventDetail.acf?.event_date_txt && !isLoading">
                  <div class="decs__head">
                    <img
                      src="@/assets/img/event/event_detail_ico_1.svg"
                      alt="event detail date"
                    />
                    <span>日時：</span>
                  </div>
                  <div class="decs__content">
                    <p v-html="eventDetail.acf?.event_date_txt"></p>
                  </div>
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                <div v-for="(n, index) in 1" :key="index" >
                  <PuSkeleton :count="1"/>
                </div>
              </div>
                <div class="decs__row" v-if="eventDetail.acf?.event_place && !isLoading">
                  <div class="decs__head">
                    <img
                      src="@/assets/img/event/event_detail_ico_2.svg"
                      alt="event detail place"
                    />
                    <span>場所：</span>
                  </div>
                  <div class="decs__content">
                    <p v-html="eventDetail.acf?.event_place"></p>
                  </div>
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                <div v-for="(n, index) in 1" :key="index" >
                  <PuSkeleton :count="1"/>
                </div>
              </div>
                <div class="decs__row" v-if="eventDetail.acf?.event_content && !isLoading">
                  <div class="decs__head">
                    <img
                      src="@/assets/img/event/event_detail_ico_3.svg"
                      alt="event detail content"
                    />
                    <span>内容：</span>
                  </div>
                  <div class="decs__content">
                    <p v-html="eventDetail.acf?.event_content"></p>
                  </div>
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                <div v-for="(n, index) in 1" :key="index" >
                  <PuSkeleton :count="1"/>
                </div>
              </div>
                <div class="decs__row row--contact" v-if="eventDetail.acf?.event_inquiry && !isLoading">
                  <div class="decs__head">
                    <img
                      src="@/assets/img/event/event_detail_ico_4.svg"
                      alt="event detail contact"
                    />
                    <span>問い合わせ先：</span>
                  </div>
                  <div class="decs__content">
                    <p v-html="eventDetail.acf?.event_inquiry"></p>
                  </div>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <div v-for="(n, index) in 1" :key="index" >
                  <PuSkeleton :count="1"/>
                </div>
                </div>
                <div class="btn__holder" v-if="eventDetail.acf?.reserve_url && !['予約不要', '非表示'].includes(eventDetail.acf?.reserve)">
                  <a class="btn" target="_blank" :href="eventDetail.acf?.reserve_url">
                    <span>予約はこちら</span>
                    <img
                      class="icolink"
                      src="@/assets/img/access/svgfile/ico_link_white.svg"
                      alt="ico_link_white"
                    />
                  </a>
                </div>
              </div>
              <div v-if="eventDetail.acf?.explanation" class="cont-text mb-custom">
                <p v-if="!isLoading" v-html="eventDetail.acf?.explanation"></p>
                <div class="skeleton-parent" v-if="isLoading">
                  <PuSkeleton :count="5"/>
                </div>
              </div>
              <!-- <div class="cont-silink">
                <ul class="silink__list">
                  <li class="silink__list__item">
                    <a 
                      target="_blank"
                      :href="`https://social-plugins.line.me/lineit/share?url=${eventDetailUrl}`"
                      ><img src="@/assets/img/common/si_line.svg" alt="line"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      target="_blank"
                      :href="`https://twitter.com/intent/tweet?text=${eventDetailUrl}`"
                      ><img
                        src="@/assets/img/common/si_twitter.svg"
                        alt="twitter"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      target="_blank" 
                      :href="`https://www.facebook.com/sharer/sharer.php?u=${eventDetailUrl}`"
                      ><img
                        src="@/assets/img/common/si_facebook.svg"
                        alt="facebook"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      :href="`mailto:?body=${eventDetailUrl}`"
                      class="router-link-active">
                      <img src="@/assets/img/common/si_mail.svg" alt="mail">
                    </a>
                  </li>
                </ul>
              </div> -->
              <div class="cont-leaflets"
              v-if="
                  (eventDetail.acf?.file1 &&
                  eventDetail.acf?.file_name1) ||
                  (eventDetail.acf?.file2 &&
                  eventDetail.acf?.file_name2) ||
                  (eventDetail.acf?.file3 &&
                  eventDetail.acf?.file_name3) ||
                  (eventDetail.acf?.file4 &&
                  eventDetail.acf?.file_name4) ||
                  (eventDetail.acf?.file5 &&
                  eventDetail.acf?.file_name5) && !isLoading">
                <h3>イベントチラシ</h3>
                <ul>
                  <li v-if="eventDetail.acf?.file1 && eventDetail.acf?.file_name1">
                    <a target="_blank" :href="$func.formatUrl(eventDetail.acf?.file1)">{{ eventDetail.acf?.file_name1 }}</a>
                  </li>
                  <li v-if="eventDetail.acf?.file2 && eventDetail.acf?.file_name2">
                    <a target="_blank" :href="$func.formatUrl(eventDetail.acf?.file2)">{{ eventDetail.acf?.file_name2 }}</a>
                  </li>
                  <li v-if="eventDetail.acf?.file3 && eventDetail.acf?.file_name3">
                    <a target="_blank" :href="$func.formatUrl(eventDetail.acf?.file3)">{{ eventDetail.acf?.file_name3 }}</a>
                  </li>
                  <li v-if="eventDetail.acf?.file4 && eventDetail.acf?.file_name4">
                    <a target="_blank" :href="$func.formatUrl(eventDetail.acf?.file4)">{{ eventDetail.acf?.file_name4 }}</a>
                  </li>
                  <li v-if="eventDetail.acf?.file5 && eventDetail.acf?.file_name5">
                    <a target="_blank" :href="$func.formatUrl(eventDetail.acf?.file5)">{{ eventDetail.acf?.file_name5 }}</a>
                  </li>
                </ul>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton style="height: 100px;" :count="1"/>
              </div>
            </div>
          </div>
        </div>
        <div class="cont-bottom">
          <div class="container">
            <div class="event-detail__holder" >
              <div class="event-list" v-if="eventList.length != 0 && (eventList[0] || eventList[1])">
                <fragment v-for="(item, index) in eventList" :key="index">
                <div class="event-list__item" v-if="index <= 1 && item != null">
                  <router-link class="item-parent" :to="'/event/' + item.id">
                    <div style="z-index: 5;" class="itemstatus__new__banner" v-if="diffDate(item.acf?.start_date + ' ' + item.acf?.start_time) <= 7">
                      <img src="@/assets/img/top/portal_icon.svg" alt="" />
                      <div class="itemstatus__new__banner__text">
                        NEW
                      </div>
                    </div>
                    <div
                      v-if="item.acf?.image1 || item.acf?.title && item.acf?.image1 != '' || item.acf?.image1 != false"
                      class="item__img"
                      :style="{backgroundImage: `url(${$func.formatUrl(item.acf?.image1)})`}"
                    >
                      <img
                        :src="$func.formatUrl(item.acf?.image1)"
                        :alt="item.acf?.title"
                      />
                    </div>
                    <div class="item__img"
                      :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }"
                      v-if="item.acf?.image1 === '' || item.acf?.image1 === false" > 
                      <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
                    </div>
                    <div class="item__text">
                      <ul class="item__cate" v-if="item.acf?.genre_icon || item.acf?.target_icon || item.acf?.organizer_icon">
                        <li v-if="item.acf?.genre_icon">{{ item.acf?.genre_icon }}</li>
                        <li v-if="item.acf?.target_icon">{{ item.acf?.target_icon }}</li>
                        <li v-if="item.acf?.organizer_icon">{{ item.acf?.organizer_icon }}</li>
                      </ul>
                      <span class="item__title"
                        >{{ item.acf?.title }}</span
                      >
                      <ul class="item__tag">
                        <li v-if="item.acf?.tag != null && item.acf?.tag != ''" :class="item.acf?.tag === '限定' ? 'txt_c_red' : ''">#住民限定</li>
                        <li v-if="item.acf?.paid != null && item.acf?.paid != ''" :class="item.acf?.paid === '有料' ? 'txt_c_red' : ''">#{{ item.acf?.paid }}</li>
                        <li v-if="['要予約', '予約可', '予約不要'].includes(item.acf?.reserve)">#{{ item.acf?.reserve }}</li>
                      </ul>
                      <span class="item__date" v-if="item.acf?.event_start_date || item.acf?.event_end_date">{{ formatDate(item.acf?.event_start_date) }}({{ formatWeekDay(item.acf?.event_start_date) }})〜{{ formatDate(item.acf?.event_end_date) }}({{ formatWeekDay(item.acf?.event_end_date) }})</span>
                    </div>
                  </router-link>
                </div>
                <div  class="event-list__item" v-if="item == null" style="background: none;"></div>
              </fragment>
              </div>
              <fragment v-for="(item, index) in eventList" :key="index"> 
                <div class="btn-pre" v-if="index === 0 && item != null && (eventList.length != 0 && (eventList[0] || eventList[1]))">
                  <router-link :to="'/event/' + item.id">
                    <img
                      src="@/assets/img/info-detail/info-top-icon-pre.svg"
                      alt="info-top-icon-pre"/>前の記事を見る
                  </router-link>
                </div>
                <div class="btn-pre" v-if="index === 0 && item == null && (eventList.length != 0 && (eventList[0] || eventList[1]))">
                  
                </div>
                <div class="btn-next" v-if="index === 1 && item != null && (eventList.length != 0 && (eventList[0] || eventList[1]))">
                  <router-link :to="'/event/' + item.id">次の記事を見る
                    <img src="@/assets/img/info-detail/info-top-icon-next.svg" alt="info-top-icon-next"/>
                  </router-link>
                </div>
              </fragment>
              <div class="btn-list">
                <router-link to="/event">一覧へ戻る</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="container">
          <div class="btn-list">
            <router-link to="/event">一覧へ戻る</router-link>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>


<script>
import { Fragment } from "vue-fragment";
import { RouterLink } from "vue-router";
import { sliderSite } from "@/assets/js/home";
import CONSTANT from "@/constant.js";
import { getUrl, formatDate, formatWeekDay, diffDate, metaData, getItemNextPrev, formatUrlDetail } from '@/utils/helper';
import router from "@/router";

export default {
  name: "EventDetail",
  props: {
    // eventListChild: {
    //   type: Array,
    // },
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Fragment
  },
  data() {
    return {
      eventDetail: [],
      eventList: [],
      isLoading: true,
      dataFilter: CONSTANT.dataFilter[0],
      urlNowRinting: CONSTANT.dataImageNowrinting,
      eventDetailUrl: window.location.href,
    };
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    formatDate,
    formatWeekDay,
    diffDate,
    getItemNextPrev,
    formatUrlDetail
  },
  created() {
    this.isLoading = true
    getUrl(`/event/${this.$route.params.id}`)
      .then((response) => {
        let deliveryMedia = response.data.acf?.delivery_media; 
        if(deliveryMedia.includes(this.dataFilter.town)) { 
          this.eventDetail = response.data;
        } else { 
           this.$router.push('/timeout')
        }

        metaData(
          `${this.eventDetail.acf?.title ? this.eventDetail.acf?.title : ''} | HARUMIFLAGタウンポータル`,
          '',
          'HARUMIFLAGタウンポータル',
          'article',
          `${formatUrlDetail(this.eventDetail.acf?.image1)}`
        )

        this.isLoading = false
      })
      .catch((e) => {
        console.log(e);
         this.$router.push('/NotFound')
      });

      this.isLoading = true
      getUrl(`/event`)
      .then((response) => {
        const dataEventFilter = this.$func.filterByDeliveryMedia(response.data);
        this.eventList = this.getItemNextPrev(dataEventFilter,this.$route.params.id );
        this.isLoading = false
      })
      .catch((e) => {
        console.log(e);
      });
  },
  updated() {
    sliderSite()
  }
};
</script>